<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createTask') }}</h1>
      <div class="form-container">
        <TaskForm  @save="save"
                   :defaultType="detail.type">
        </TaskForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import TaskForm from '@/components/TaskForm'

  export default {
    components: {
      DashboardLayout,
      TaskForm
    },
    methods: {
      save(taskForm) {
        this.$store.dispatch('Task/create', {
          task: taskForm,
          documentId: this.detail.id
        }).then(task => {
          this.$router.push({
            name: 'taskDetail',
            params: {
              documentId: this.detail.id,
              taskId: task.id
            }
          })
        })
      }
    },
    computed: {
      ...mapState('Document', ['detail']),
      breadcrumbs() {
        return [
          { name: 'documents', path: 'documents' },
          {
            name: 'documentDetail',
            path: {
              name: 'documentDetail',
              params: {documentId: this.$route.params.documentId}
            }
          },
          { name: 'createTask' }
        ]
      }
    }
  }
</script>
